<style scoped lang="scss">
.wrap-tec{
  margin-bottom: 80px;
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <div class="banner">
      <img src="@/assets/images/banner_11.png" class="img-fluid">
      <div class="info">
        <div class="container">
          <h1>提取扩增测序</h1>
          <h2 class="mt10">Extraction amplification sequencing</h2>
        </div>
      </div>
    </div>
    <section class="container">
      <p class="desc">承接各类样品基因组DNA提取、PCR扩增及测序检测</p>
      <div class="c-title">结果交付<small>Delivery Of Results</small></div>
      <el-row type="flex" align="bottom">
        <el-col :span="12">
          <img src="@/assets/images/extraction_1.png" class="img-fluid">
        </el-col>
        <el-col :span="12">
          <div class="required">
            <p class="mb20">1、提供电子版样品信息表，DNA、PCR产物琼脂糖电泳胶图； </p>
            <p class="mb20">2、提供提取好的DNA样品，存于1.5 mL离心管或者96孔PCR板 中； </p>
            <p class="mb20">3、提供测序原始峰图及结果序列文件； </p>
            <p>4、如有要求，可做SNP位点分析。</p>
          </div>
        </el-col>
      </el-row>
      <div class="c-title">实验案例<small>Experimental Case</small></div>
      <div class="tc"><img src="@/assets/images/extraction_2.png"></div>
      <el-table
        class="mt30"
        :data="pageData.extractionTable">
        <el-table-column
          prop="name"
          label="样品名称">
        </el-table-column>
        <el-table-column
          label="MKK4基因">
          <el-table-column
            prop="k41"
            label="第一个位点">
          </el-table-column>
          <el-table-column
            prop="k42"
            label="第二个位点">
          </el-table-column>
          <el-table-column
            prop="k43"
            label="第二个位点">
          </el-table-column>
          <el-table-column
            prop="k44"
            label="第二个位点">
          </el-table-column>
          <el-table-column
            prop="k45"
            label="第二个位点">
          </el-table-column>
        </el-table-column>
        <el-table-column
          label="MKK7基因">
          <el-table-column
            prop="k71"
            label="第一个位点">
          </el-table-column>
          <el-table-column
            prop="k72"
            label="第二个位点">
          </el-table-column>
          <el-table-column
            prop="k73"
            label="第二个位点">
          </el-table-column>
          <el-table-column
            prop="k74"
            label="第二个位点">
          </el-table-column>
          <el-table-column
            prop="k75"
            label="第二个位点">
          </el-table-column>
        </el-table-column>
      </el-table>
      <p class="mt20">注：以上为部分数据，详情请联系客服。</p>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['pageData'])
  },
}
</script>



// WEBPACK FOOTER //
// src/views/tec/extraction.vue